var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"List"}},[_c('div',{staticClass:"mt-4"},[_c('OrderList')],1)]),_c('vs-tab',{attrs:{"label":"Group by Address"}},[_c('div',{staticClass:"mt-4"},[_c('GroupByAddress')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }